<script lang="ts">
  import LinkComp from "$components/link.svelte";
  import ImageComp from "$components/image.svelte";
  import Arrow from "$components/arrow/index.svelte";
  export let standings: Record<string, any>[] = [];
</script>

<div class="table-wrapper">
  <table>
    <thead>
      <tr>
        <th class="pf-700">Position</th>
        <th class="pf-700">Team</th>
        <th class="pf-700">Points</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {#if standings.length}
        {#each standings as item}
          {@const { position, team, points, slug, path } = item}
          <tr>
            <td class="pf-500">{position}</td>
            <td>
              <div class="performer grid">
                <div class="logo">
                  <ImageComp image={{ path }} className="team-logo" />
                </div>
                <span class="pf-500">{team}</span>
              </div>
            </td>
            <td class="pf-500">{points}</td>
            <td>
              <LinkComp href={slug}>
                <Arrow />
              </LinkComp>
            </td>
          </tr>
        {/each}
      {/if}
    </tbody>
  </table>
</div>

<style lang="scss">
  .table-wrapper {
    border: 1px solid #d8d8d8;
    border-radius: 0.4375em 0.4375em 0em 0em;
    background: #fff;

    table {
      thead {
        tr {
          th {
            padding: 2em 1.5em;
            font-size: 1.125em;
            line-height: 0.75em;
          }
        }
      }
      tbody {
        tr {
          height: 4.35em;
          font-size: 18px;
          line-height: 12px;
          &:nth-child(odd) {
            background: #f8f8f8;
          }
          td {
            padding: 0 0 0 10px;
            &:nth-child(1) {
              padding-left: 50px;
            }
            &:nth-child(3) {
              padding-left: 40px;
            }

            &:last-child {
              text-align: center;
            }
            .performer {
              grid-template-columns: 2em auto;
              gap: 0.6em;
              align-content: center;
              span {
                align-self: center;
                line-height: 1em;
              }
              .logo {
                width: 2em;
                height: 2em;
              }
            }
          }
        }
      }
    }
  }
</style>
